import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export function Header({ clsName = '', calcObj, i18n = 'calculators.mm100.progress.' }: any) {
    const { totalStep, currentStep, stepTitle } = calcObj;
    const { useLang, useEffect, useState } = useGlobal();
    const [headerBordered, setHeaderBordered] = useState(false);
    const { t } = useLang('shared');

    useEffect(() => {
        if (window) {
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const handleScroll = () => {
        const htmlEl = document?.querySelector('html') as HTMLElement;
        if (htmlEl) {
            setHeaderBordered(htmlEl.scrollTop > 0);
        }
    };

    return (
        <div className={`calculators-headerH5 ${clsName} ${css.calculatorsHeaderH5}`} style={{ borderBottom: headerBordered ? '.01rem solid #e9e9e9' : '0' }}>
            <div className="steps">
                {stepTitle?.map((step: any, k: number) => {
                    if (k === stepTitle.length - 1) {
                        return (
                            <div
                                className={`step-item ${k === currentStep - 1 ? 'last-step-active' : 'last-step'}`}
                                key={k}
                                style={{
                                    width: `calc(100% / ${totalStep})`,
                                    background: k === currentStep - 1 ? '#165dff' : '#dedede',
                                }}
                            />
                        );
                    }
                    return (
                        <div
                            className="step-item"
                            key={k}
                            style={{
                                width: `calc(100% / ${totalStep})`,
                                background: k < currentStep - 1 ? '#165dff' : '#dedede',
                            }}
                        />
                    );
                })}
                <div className="left-cover">
                    <div className="cover"></div>
                </div>
                <div className={`right-cover ${calcObj?.currentStep === stepTitle?.length ? '' : 'disactive'}`}>
                    <div className="cover"></div>
                </div>
            </div>
            <div className="step-title">{t(`${i18n}${stepTitle[currentStep - 1]}`)}</div>
        </div>
    );
}
